import React from 'react';
import { noParkingResource } from '@/lib/utils-reserve';
import ReserveFieldParkingList from '@/components/reserve/ReserveFieldParkingList/ReserveFieldParkingList';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';
import { capitalize } from '@gettactic/helpers/src';
import { useCustomParkingVerbiageOnWeb as useCustomParkingVerbiage } from '@/hooks/useCustomParkingVerbiage';

export const ReserveFormParkingList: React.FC = () => {
  const { form, defaultValues, parkingResourcesList, allowParking } =
    useReserveForm();
  const customParkingVerbiage = useCustomParkingVerbiage();

  const defaultParking = React.useMemo(() => {
    const defParking =
      parkingResourcesList?.find(
        (x) => x.id === defaultValues.parking_resource_id
      ) ?? noParkingResource;
    if (customParkingVerbiage) {
      const text = `No ${capitalize(customParkingVerbiage)} Space`;
      defParking.name = text;
      defParking.label = text;
    }
    return defParking;
  }, [
    parkingResourcesList,
    defaultValues,
    noParkingResource,
    customParkingVerbiage
  ]);

  if (!allowParking) return null;

  return (
    <ReserveFieldParkingList
      noParkingResource={noParkingResource}
      parkingResourcesList={parkingResourcesList}
      defaultValue={defaultParking}
      form={form}
      errors={form.formState.errors}
    />
  );
};
